export default __webpack_public_path__ + "static/media/480_store03-en-mobile.49cb39cc.png";